import MenuItem from "@material-ui/core/MenuItem";
import {NormalParams} from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/NormalParams";
import TextField from "@material-ui/core/TextField";
import React from "react";
import InputRules from "./InputRules";

type NormalParamsInputProps = {
  name: string,
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, error?: boolean) => void;
  value: NormalParams,
  isMeanValid: boolean,
  isStdValid: boolean,
  isMedianValid: boolean,
  isErrorFactorValid: boolean,
  isP5Valid: boolean,
  isP95Valid: boolean,
  disabled?: boolean
}

const NormalParamsInput = (props: NormalParamsInputProps) => {

  const { name, onChange, value, isMeanValid, isStdValid, isMedianValid, isErrorFactorValid, isP5Valid, isP95Valid, disabled } = props;

  const isNormalParamsValid = InputRules.isNormalParamsValid(value);

  const handleParamsChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const isNormalParamsValid = InputRules.isNormalParamsValid(e.target.value);

    // the actual params corresponding target normal param type
    let isParamsValid = false;
    if (e.target.value === NormalParams.MeanStd) {
      isParamsValid = isMeanValid && isStdValid;
    }
    else if (e.target.value === NormalParams.MedianErrorFactor) {
      isParamsValid = isMedianValid && isErrorFactorValid;
    }
    else if (e.target.value === NormalParams.Percentiles) {
      isParamsValid = isP5Valid && isP95Valid;
    }

    onChange(e, !isNormalParamsValid || !isParamsValid);
  };

  return (
    <TextField
      required
      select
      label="params"
      name={name}
      value={value}
      onChange={handleParamsChange}
      margin="normal"
      variant="outlined"
      fullWidth
      helperText={isNormalParamsValid ? undefined : InputRules.DESCRIPTIONS.NORMAL_PARAMS}
      error={!isNormalParamsValid}
      disabled={disabled}
    >
      <MenuItem key={NormalParams.MeanStd} value={NormalParams.MeanStd}>
        {NormalParams.MeanStd}
      </MenuItem>
      <MenuItem key={NormalParams.MedianErrorFactor} value={NormalParams.MedianErrorFactor}>
        {NormalParams.MedianErrorFactor}
      </MenuItem>
      <MenuItem key={NormalParams.Percentiles} value={NormalParams.Percentiles}>
        {NormalParams.Percentiles}
      </MenuItem>
    </TextField>
  );
};

export default NormalParamsInput
